"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguagesSelectorWrapper = exports.LoadingContainer = exports.Link = exports.DefaultImageIcon = exports.DefaultImageContainer = exports.addToCartCol = exports.PartNumber = exports.PartRow = exports.DocumentsLink = exports.SectionTitle = exports.TableCol = exports.TableColFirst = exports.TableRow = exports.Table = exports.SectionRow = exports.ProductDetailsRow = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const styled_bootstrap_grid_1 = require("styled-bootstrap-grid");
const Typography_1 = __importDefault(require("../../../Components/UI/Typography"));
const svg_components_1 = require("@/assets/svg-components");
exports.ProductDetailsRow = (0, styled_components_1.default)(styled_bootstrap_grid_1.Row) `
  margin-top: ${props => props.theme.spacing.m6}px;
  margin-bottom: ${props => props.theme.spacing.l5}px;

  @media (max-width: ${props => props.theme.breakpoints.sm}px) {
    margin-top: 0;
    margin-bottom: ${props => props.theme.spacing.m5}px;
  }
`;
exports.SectionRow = (0, styled_components_1.default)(styled_bootstrap_grid_1.Row) `
  margin-bottom: ${props => props.theme.spacing.l1}px;

  @media (max-width: ${props => props.theme.breakpoints.sm}px) {
    margin-bottom: ${props => props.theme.spacing.m5}px;
  }
`;
exports.Table = styled_components_1.default.table `
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
`;
exports.TableRow = styled_components_1.default.tr `
  width: 100%;
`;
exports.TableColFirst = styled_components_1.default.td `
  width: 50%;
  border: 1px solid ${props => props.theme.palette.DARK_GRAY_20};
  padding: ${props => props.theme.spacing.s2}px ${props => props.theme.spacing.s3}px;
  background-color: ${props => props.theme.palette.LIGHT_GRAY_10};
`;
exports.TableCol = styled_components_1.default.td `
  width: 50%;
  border: 1px solid ${props => props.theme.palette.DARK_GRAY_20};
  padding: ${props => props.theme.spacing.s2}px ${props => props.theme.spacing.s3}px;
`;
exports.SectionTitle = (0, styled_components_1.default)(Typography_1.default) `
  margin: 0 0 ${props => props.theme.spacing.s4}px 0;
`;
exports.DocumentsLink = styled_components_1.default.a `
  text-decoration: underline;
  color: ${props => props.theme.palette.BLUE_100};
  transition: ${props => props.theme.attributes.transition.fast};

  :hover {
    color: ${props => props.theme.palette.ORANGE_100};
  }
`;
exports.PartRow = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  margin-top: ${props => props.theme.spacing.s2}px;
  gap: ${props => props.theme.spacing.s6}px;
`;
exports.PartNumber = (0, styled_components_1.default)(Typography_1.default) `
  color: ${props => (props.hasLink ? props.theme.palette.BLUE_100 : props.theme.palette.DARK_GRAY_100)};
  width: auto;
`;
exports.addToCartCol = (0, styled_components_1.default)(styled_bootstrap_grid_1.Col) `
  @media (max-width: ${props => props.theme.breakpoints.lg}px) {
    margin-top: ${props => props.theme.spacing.m1}px;
  }
`;
exports.DefaultImageContainer = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${props => props.theme.spacing.s2}px;
  border: 1px solid ${props => props.theme.palette.LIGHT_GRAY_20};
  width: 100%;
  aspect-ratio: 1 / 1;
`;
exports.DefaultImageIcon = (0, styled_components_1.default)(svg_components_1.NoImageIcon) `
  width: 80%;
  height: 80%;
  object-fit: cover;
`;
exports.Link = styled_components_1.default.a `
  text-decoration: none;
`;
exports.LoadingContainer = styled_components_1.default.div `
  height: 100%;
  display: flex;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
`;
exports.LanguagesSelectorWrapper = styled_components_1.default.div `
  display: flex;
  justify-content: flex-end;
`;
exports.default = {
    ProductDetailsRow: exports.ProductDetailsRow,
    SectionRow: exports.SectionRow,
    Table: exports.Table,
    TableRow: exports.TableRow,
    TableCol: exports.TableCol,
    SectionTitle: exports.SectionTitle,
    DocumentsLink: exports.DocumentsLink,
    PartRow: exports.PartRow,
    PartNumber: exports.PartNumber,
    LoadingContainer: exports.LoadingContainer
};
